import { FilterInfo, FilterValue } from "types/pagination";

/** Returns "aqlQueryV2" when v2 is active, "aqlQuery" otherwise */
export function getAqlFilterKey(isAQLV2Active: boolean) {
  return isAQLV2Active ? "aqlQueryV2" : "aqlQuery";
}

/** Reads AQL query value from filters using the correct key */
export function getAqlValueFromFilters(
  filters: FilterInfo,
  isAQLV2Active: boolean,
): FilterValue[] | undefined {
  return filters[getAqlFilterKey(isAQLV2Active)];
}

/**
 * When AQL V2 is active, remap the `aqlQuery` key to `aqlQueryV2` in the
 * outgoing API filter payload so the backend can distinguish query versions.
 */
export function remapAqlKeyForV2(
  filters: FilterInfo,
  isAQLV2Active: boolean,
): FilterInfo {
  if (isAQLV2Active && "aqlQuery" in filters) {
    const { aqlQuery, ...rest } = filters;
    return { ...rest, aqlQueryV2: aqlQuery };
  }
  return filters;
}

/**
 * Maps a widget's filterType to the isVisualMode URL parameter value
 * for redirect navigation to the Findings page.
 *
 * - "visual" -> true  (Findings page shows Visual filter builder)
 * - "aql"    -> false (Findings page shows AQL text input)
 * - other    -> undefined (legacy behavior, no isVisualMode in URL)
 */
export function getIsVisualModeForRedirect(
  filterType?: string,
): boolean | undefined {
  if (filterType === "visual") return true;
  if (filterType === "aql") return false;
  return undefined;
}
